// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
var PropertyWizardRelay__Description__Message = require("./PropertyWizardRelay__Description__Message.bs.js");
var PropertyWizardRelay__Description__Subject = require("./PropertyWizardRelay__Description__Subject.bs.js");
var PropertyWizardRelay__Description__Website = require("./PropertyWizardRelay__Description__Website.bs.js");
var PropertyWizardRelayDescription_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescription_draft_graphql.bs.js");
var PropertyWizardRelay__Description__Description = require("./PropertyWizardRelay__Description__Description.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
var PropertyWizardRelayDescription_formState_graphql = require("../../../__generated__/PropertyWizardRelayDescription_formState_graphql.bs.js");
var PropertyWizardRelay__Description__DisplayNeighborhood = require("./PropertyWizardRelay__Description__DisplayNeighborhood.bs.js");

var convertFragment = PropertyWizardRelayDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescription_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescription_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescription_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescription_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayDescription_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescription_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Description(props) {
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var draft = use(props.draft);
  var formState = use$1(props.formState);
  var subjectIsValid = PropertyWizardFormRelay__Validators__Description.Subject.useIsValid(draft.fragmentRefs);
  var stepHasBeenTouched = formState.stepDescriptionTouched;
  var subject = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Draft",
        _0: (function (dp, value) {
            return {
                    chapterPreferenceMlsComingSoonActivated: dp.chapterPreferenceMlsComingSoonActivated,
                    draftProperty: dp.draftProperty,
                    message: dp.message,
                    serverDraftId: dp.serverDraftId,
                    status: dp.status,
                    subject: value,
                    timeZone: dp.timeZone
                  };
          })
      }, stepHasBeenTouched, draft.subject, subjectIsValid);
  var messageIsValid = PropertyWizardFormRelay__Validators__Description.Message.useIsValid(draft.fragmentRefs);
  var message = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "Draft",
        _0: (function (dp, value) {
            return {
                    chapterPreferenceMlsComingSoonActivated: dp.chapterPreferenceMlsComingSoonActivated,
                    draftProperty: dp.draftProperty,
                    message: value,
                    serverDraftId: dp.serverDraftId,
                    status: dp.status,
                    subject: dp.subject,
                    timeZone: dp.timeZone
                  };
          })
      }, stepHasBeenTouched, draft.message, messageIsValid);
  var match$1 = subject.focused;
  var tmp;
  if (match$1) {
    if (typeof mode !== "object") {
      tmp = Caml_option.some(TipBoxes.PropertyWizard.headline);
    } else {
      switch (mode.TAG) {
        case "Edit" :
            tmp = Caml_option.some(TipBoxes.PropertyWizard.headline);
            break;
        case "Rebroadcast" :
            tmp = Caml_option.some(JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RebroadcastHeadlineTipBox.make, {}));
            break;
        case "BroadcastQuietSeller" :
            tmp = undefined;
            break;
        
      }
    }
  } else {
    tmp = undefined;
  }
  var subjectField = JsxRuntime.jsx(FormV5.FormSection.make, {
        tipbox: tmp,
        children: JsxRuntime.jsx(PropertyWizardRelay__Description__Subject.make, {
              subject: subject
            })
      });
  var match$2 = message.focused;
  var tmp$1;
  if (match$2) {
    if (typeof mode !== "object") {
      tmp$1 = Caml_option.some(TipBoxes.PropertyWizard.tanMessage);
    } else {
      switch (mode.TAG) {
        case "Edit" :
            tmp$1 = Caml_option.some(TipBoxes.PropertyWizard.tanMessage);
            break;
        case "Rebroadcast" :
            tmp$1 = Caml_option.some(JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RebroadcastMessageTipBox.make, {}));
            break;
        case "BroadcastQuietSeller" :
            tmp$1 = undefined;
            break;
        
      }
    }
  } else {
    tmp$1 = undefined;
  }
  var messageField = JsxRuntime.jsx(FormV5.FormSection.make, {
        tipbox: tmp$1,
        children: JsxRuntime.jsx(PropertyWizardRelay__Description__Message.make, {
              draft: draft.fragmentRefs,
              message: message
            })
      });
  var displayNeighborhoodField = JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(PropertyWizardRelay__Description__DisplayNeighborhood.make, {
              draft: draft.fragmentRefs,
              formState: formState.fragmentRefs,
              stepHasBeenTouched: stepHasBeenTouched
            })
      });
  var websiteField = JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(PropertyWizardRelay__Description__Website.make, {
              draft: draft.fragmentRefs,
              stepHasBeenTouched: stepHasBeenTouched
            })
      });
  var descriptionField = JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(PropertyWizardRelay__Description__Description.make, {
              draft: draft.fragmentRefs,
              stepHasBeenTouched: stepHasBeenTouched
            })
      });
  var tmp$2;
  var exit = 0;
  if (typeof mode !== "object" || mode.TAG !== "Rebroadcast") {
    exit = 1;
  } else {
    tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            subjectField,
            messageField,
            displayNeighborhoodField,
            websiteField,
            descriptionField
          ]
        });
  }
  if (exit === 1) {
    tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            subjectField,
            displayNeighborhoodField,
            websiteField,
            descriptionField,
            messageField
          ]
        });
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(tmp$2)
            });
}

var FormSection;

var Elements;

var Validators;

var FormUtils;

var SubjectField;

var DisplayNeighborhoodField;

var DescriptionField;

var MessageField;

var WebsiteField;

var make = PropertyWizardRelay__Description;

exports.FormSection = FormSection;
exports.Elements = Elements;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.SubjectField = SubjectField;
exports.DisplayNeighborhoodField = DisplayNeighborhoodField;
exports.DescriptionField = DescriptionField;
exports.MessageField = MessageField;
exports.WebsiteField = WebsiteField;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* FormV5 Not a pure module */
